import React from 'react'
import moment from 'moment'
import Modal from './../../../../../components/modal/modal.component'
import Button from '../../../../../components/buttons/buttons.component'
import styled from 'styled-components'
import ModalTrip from './modal-trip.component'
import ModalTripPromotion from './modal-trip-promotion.component'
import { connect } from 'react-redux'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'
import { Creators as ClientTicketModalCreators } from '../../../../../ducks/client-ticket-modal/client-ticket-modal'
import { toastActions } from '../../../../../actions'
import { bindActionCreators } from 'redux'
import { AdminTicketService } from './../../../../../services/admin-ticket.service'
import { ClientTicketService } from './../../../../../services/client-ticket.service'
import { getApiErrorMessage } from './../../../../../services/axios.service'
import { PaymentStatus } from '../../../../../constants/ticket-sale.constants'
import FontAwesome from 'react-fontawesome'
import { GRAY, GREEN, LIGHTGRAY } from '../../../../../styles/colors.style'
import { breakpoints } from '../../../../../constants'
import FileSaver from 'file-saver'
import { base64ToBlob } from '../../../../../helpers/image.helper'
import { tripsDirections } from '@constants'
import PixInfo from '../../../../../components/pix/pix-info.component'

const CANCELED_ORDER_STATUSES = ['Falhou', 'Cancelado', 'Reembolsado']

function formatCurrency(value) {
	return Number(value || 0).toLocaleString('pt-BR', {
		style: 'currency',
		currency: 'BRL',
	})
}

function OrderInfoPanel({ order, onShowPixQrCode }) {
	const isCanceled = CANCELED_ORDER_STATUSES.includes(order.status)
	const total =
		(order.totalBpe || 0) +
		(order.totalConvenience || 0) +
		(order.totalJuros || 0) +
		(order.totalToll || 0) +
		(order.totalFee || 0) +
		(order.totalInsurance || 0) +
		(order.totalOther || 0) -
		(order.totalDiscount || 0)

	return (
		<StyledOrderInfo>
			<div className="row">
				<span>Pedido</span>
				<span>{order.orderNumber}</span>
			</div>
			<div className="row">
				<span>Data da compra</span>
				<span>{moment(order.dateCreated).format('DD/MM/YYYY HH:mm')}</span>
			</div>
			<div className="row">
				<span>Situação</span>
				<span className={isCanceled ? 'danger' : ''}>{order.status}</span>
			</div>
			<div className="row">
				<span>Forma de pagamento</span>
				<span>{order.paymentType}</span>
			</div>
			{order.totalBpe > 0 && (
				<div className="row">
					<span>Tarifa</span>
					<span>{formatCurrency(order.totalBpe)}</span>
				</div>
			)}
			{order.totalConvenience > 0 && (
				<div className="row">
					<span>Taxa de conveniência</span>
					<span>{formatCurrency(order.totalConvenience)}</span>
				</div>
			)}
			{order.totalToll > 0 && (
				<div className="row">
					<span>Pedágio</span>
					<span>{formatCurrency(order.totalToll)}</span>
				</div>
			)}
			{order.totalFee > 0 && (
				<div className="row">
					<span>Taxa</span>
					<span>{formatCurrency(order.totalFee)}</span>
				</div>
			)}
			{order.totalInsurance > 0 && (
				<div className="row">
					<span>Seguro</span>
					<span>{formatCurrency(order.totalInsurance)}</span>
				</div>
			)}
			{order.totalJuros > 0 && (
				<div className="row">
					<span>Juros</span>
					<span>{formatCurrency(order.totalJuros)}</span>
				</div>
			)}
			{order.totalOther > 0 && (
				<div className="row">
					<span>Outros</span>
					<span>{formatCurrency(order.totalOther)}</span>
				</div>
			)}
			{order.totalDiscount > 0 && (
				<div className="row">
					<span className="discount">Desconto</span>
					<span className="discount">
						-{formatCurrency(order.totalDiscount)}
					</span>
				</div>
			)}
			<hr />
			<div className="row total">
				<span>Total</span>
				<span>{formatCurrency(total)}</span>
			</div>
			{order.pixImageQrCodeUrl && (
				<StyledButtonContainer>
					<Button secondary type="button" onClick={onShowPixQrCode}>
						<FontAwesome name="qrcode" style={{ marginRight: '5px' }} />
						Ver QR Code do Pix
					</Button>
				</StyledButtonContainer>
			)}
		</StyledOrderInfo>
	)
}

const StyledOrderInfo = styled.div`
	margin-bottom: 15px;

	.row {
		display: flex;
		justify-content: space-between;
		align-items: baseline;
		flex-wrap: wrap;
		gap: 2px 12px;
		font-size: 1.5rem;
		padding: 3px 0;

		span:first-child {
			color: ${GRAY};
		}

		span:last-child {
			font-weight: 600;
			text-align: right;
		}

		.danger {
			color: #cc4f4f;
		}

		.discount {
			color: ${GREEN};
		}

		@media screen and (max-width: ${breakpoints.MOBILE}px) {
			flex-direction: column;
			align-items: flex-start;
			gap: 0;
			padding: 6px 0;

			span:last-child {
				text-align: left;
			}
		}
	}

	.total span {
		font-weight: 700;
	}

	hr {
		border-top: 1px solid ${LIGHTGRAY};
	}
`

class ClientTicketModalComponent extends React.Component {
	render() {
		const {
			user,
			order,
			isAdmin,
			tickets,
			pixData,
			onReturn,
			closeModal,
			sourceCall,
			isModalOpen,
			orderNumber,
			toastSuccess,
			promotionCoupon,
			hasTicketsToShow,
			isQRCodeModalOpen,
		} = this.props

		const showPixQrCode = () => {
			ClientTicketService.getPixQrCode(order.id)
				.then((pixImageQrCode) => {
					this.props.openQrCodeModal({
						pixImageQrCode,
						pixValidity: order.pixValidity,
					})
				})
				.catch(() => { })
		}

		const downloadPixQrCode = () => {
			FileSaver.saveAs(
				base64ToBlob(pixData.pixImageQrCode),
				`QRCode-Pix-Pedido-${orderNumber}.png`
			)
		}

		const resendTripData = () => {
			toastSuccess({ message: 'Os bilhetes foram enviados por e-mail' })
			if (isAdmin) {
				AdminTicketService.resendTripData(orderNumber)
			} else {
				ClientTicketService.resendTripData(orderNumber)
			}
		}

		const generateBpe = async (tickets) => {
			const firstTicket = tickets[0]
			const userId =
				firstTicket.buyerId !== null &&
					firstTicket.buyerId !== undefined &&
					firstTicket.buyerId !== ''
					? firstTicket.buyerId
					: user.id
			ClientTicketService.generateBpeFiles(orderNumber, userId)
		}
		const downloadBpe = async () => {
			const { showLoading, hideLoading, toastDanger } = this.props

			// Pedidos vindos da MuviHub (order presente) usam o endpoint novo,
			// que entrega os documentos de todos os bilhetes num ZIP só.
			if (order) {
				return downloadOrderDocuments(
					order,
					showLoading,
					hideLoading,
					toastDanger
				)
			}

			const error = () => {
				toastDanger({
					message: 'Não foi possível fazer o download dos arquivos.',
				})
				hideLoading()
			}

			showLoading()
			await generateBpe(tickets)
			tickets.map((f) => {
				const userId =
					f.buyerId !== null && f.buyerId !== undefined && f.buyerId !== ''
						? f.buyerId
						: user.id
				ClientTicketService.download(
					orderNumber,
					f.trackNumber,
					userId,
					'Checkin de Embarque'
				)
					.then((response) => {
						const { data } = response
						if (data)
							FileSaver.saveAs(
								data,
								`Checkin de Embarque ${f.passengerName.toUpperCase()}.png`
							)
					})
					.catch(() => error())
					.finally(() => hideLoading())

				ClientTicketService.download(
					orderNumber,
					f.trackNumber,
					userId,
					'Passagem DaBPE'
				)
					.then((response) => {
						const { data } = response
						if (data)
							FileSaver.saveAs(
								data,
								`Passagem DaBPE ${f.passengerName.toUpperCase()}.pdf`
							)
					})
					.catch(() => error())
					.finally(() => hideLoading())
			})
		}

		const renderFunction = hasTicketsToShow
			? renderTickets(
				tickets,
				onReturn,
				downloadBpe,
				resendTripData,
				promotionCoupon,
				sourceCall,
				user,
				isAdmin
			)
			: () => renderNoTickets(order && order.status)
		return (
			<React.Fragment>
				<Modal
					onClose={closeModal}
					isOpen={isModalOpen}
					title={<span className="orange">Informações da viagem</span>}>
					{order && <OrderInfoPanel order={order} onShowPixQrCode={showPixQrCode} />}
					{renderFunction()}
				</Modal>
				<Modal
					onClose={closeModal}
					isOpen={isQRCodeModalOpen}
					title={<span className="orange">Pagamento PIX</span>}>
					<PixInfo
						pixImageQrCode={pixData.pixImageQrCode}
						pixValidity={pixData.pixValidity}
						pixEmv={pixData.pixEmv}
						provider={pixData.provider}
						onDownload={downloadPixQrCode}
					/>
				</Modal>
			</React.Fragment>
		)
	}
}

async function downloadOrderDocuments(
	order,
	showLoading,
	hideLoading,
	toastDanger
) {
	showLoading()

	try {
		// A MuviHub entrega o BP-e de cada bilhete (já resolvido no servidor) como
		// um PDF. Salvamos um arquivo por bilhete — a partir do 2º download o
		// navegador pede permissão de "baixar vários arquivos"; é esperado.
		const { documents, missing } =
			await ClientTicketService.getOrderDocuments(order.id)

		documents.forEach((doc) => FileSaver.saveAs(doc.blob, doc.fileName))

		// Pedido sem NENHUM BP-e vem como erro (409) da própria API; aqui só
		// tratamos o parcial — avisar o que faltou, em vez de sumir em silêncio.
		if (missing && missing.length) {
			toastDanger({
				message: `Não foi possível incluir: ${missing.join(', ')}.`,
			})
		}
	} catch (error) {
		// A API já mostra sua própria mensagem (ex: "Pedido sem documentos
		// disponíveis."); só usamos essa mensagem genérica quando a falha
		// não vier com uma mensagem específica (erro de rede, etc).
		if (!getApiErrorMessage(error)) {
			toastDanger({
				message: 'Não foi possível fazer o download dos arquivos.',
			})
		}
	} finally {
		hideLoading()
	}
}

function byDeparture({ departure }, ticket) {
	return departure.localeCompare(ticket.departure)
}

function byBusSeat({ busSeatNumber }, ticket) {
	return busSeatNumber.localeCompare(ticket.busSeatNumber)
}

function isReturnTripOBSOLETE(ticketsGoing, ticket) {
	return !!ticketsGoing.filter(
		(ticketGoing) => ticketGoing.origin === ticket.destination
	).length
}

// TODO: criar selectors
function renderTickets(
	tickets,
	onReturn,
	downloadBpe,
	resendTripData,
	promotionCoupon,
	sourceCall,
	user
) {
	const sortedTickets = tickets.sort(byDeparture)

	let ticketsGoing = []
	let ticketsReturn = []

	sortedTickets.map((ticket) => {
		if (
			(!ticket.trecho && !isReturnTripOBSOLETE(ticketsGoing, ticket)) ||
			ticket.trecho === tripsDirections.IDA
		) {
			ticketsGoing.push(ticket)
		} else {
			ticketsReturn.push(ticket)
		}
	})

	let firstTicket = ticketsGoing[0]
	let lastTicket = sortedTickets[sortedTickets.length - 1]
	let hasReturnTrip = !!ticketsReturn.length
	let hasFamilyDiscount = firstTicket.familyDiscount == 'true'

	const now = new Date()
	const validateCanSend = (tickets, ticket) =>
		now <= new Date(ticket.departure) &&
		tickets.some((ticket) => ticket.canReturn)
	const canResend =
		(ticketsReturn.length && validateCanSend(ticketsReturn, lastTicket)) ||
		validateCanSend(ticketsGoing, firstTicket)
	return () => (
		<React.Fragment>
			<ModalTrip
				user={user}
				onReturn={onReturn}
				tickets={ticketsGoing}
				sourceCall={sourceCall}
				isGoing={true}
			/>
			{hasReturnTrip && <br />}
			{hasReturnTrip && (
				<ModalTrip
					onReturn={onReturn}
					tickets={ticketsReturn}
					sourceCall={sourceCall}
					isGoing={false}
				/>
			)}
			{firstTicket.status === PaymentStatus.ACTIVE && (
				<ModalTripPromotion promotionCoupon={promotionCoupon} />
			)}
			{hasFamilyDiscount ? (
				<div style={{ fontSize: '15px', margin: '10px' }}>
					<b>Observações: </b>
					<span>O Desconto Família foi aplicado nesta compra.</span>
				</div>
			) : null}
			<StyledFooterButtons>
				{canResend ? (
					<StyledButtonContainer>
						<Button primary type="button" onClick={resendTripData}>
							Enviar por e-mail
						</Button>
					</StyledButtonContainer>
				) : null}
				<Button secondary type="button" onClick={downloadBpe}>
					<span style={{ marginRight: 5 }}>
						<FontAwesome name="qrcode" size="lg" />
					</span>
					<span style={{ marginRight: 5 }}>
						<FontAwesome name="download" size="lg" />
					</span>
					Salvar Passagem(ns) Digital(is)
				</Button>
			</StyledFooterButtons>
		</React.Fragment>
	)
}

const StyledButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-left: 10px;

	@media screen and (max-width: ${breakpoints.MOBILE}px) {
		margin-left: 0px;
	}
`
const StyledFooterButtons = styled.div`
	display: flex;
	justify-content: space-between;
	flex-direction: row-reverse;

	@media screen and (max-width: ${breakpoints.MOBILE}px) {
		font-size: 1.4rem;
		display: block;
		margin: 0;
		button {
			margin: 10px 0 0 0;
		}
	}
`

function renderNoTickets(orderStatus) {
	if (orderStatus === 'Pendente') {
		return (
			<div>
				<span>
					Este pedido ainda está aguardando a confirmação do pagamento.
				</span>
				<br></br>
				<span>
					Utilize o botão "Ver QR Code do Pix" acima para efetuar o
					pagamento.
				</span>
			</div>
		)
	}

	return (
		<div>
			<span>
				Parece que algo deu errado e seu bilhete de passagem não foi gerado.
			</span>
			<br></br>
			<span>Não se preocupe, a compra não será cobrada.</span>
			<br></br>
			<span>
				Em caso de qualquer dúvida em relação a sua compra, envie e-mail
				para{' '}
				<a href="mailto:faleconosco@muviflex.com.br?Subject=Fale conosco - Muviflex site">
					faleconosco@muviflex.com.br
				</a>
			</span>
		</div>
	)
}

const mapStateToProps = ({ clientTicketModal, user }) => ({
	orderNumber: clientTicketModal.orderNumber,
	user,
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			toastSuccess: toastActions.success,
			toastDanger: toastActions.danger,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
			openQrCodeModal: ClientTicketModalCreators.openQrCodeModal,
		},
		dispatch
	)

const ClientTicketModal = connect(
	mapStateToProps,
	mapDispatchToProps
)(ClientTicketModalComponent)

export default ClientTicketModal
